import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Itme_trade_services extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Itmes Trade Services
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>About Us</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Itmes Trade Services</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <>
                    <section
                        className="about-section section-padding fix bg-cover"
                        style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                    >
                        <div className="container">
                            <div className="about-wrapper style-2">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="about-image-items">
                                            <div className="circle-shape">
                                                <img src="assets/img/about/circle.png" alt="shape-img" />
                                            </div>
                                            <div className="counter-shape float-bob-y">
                                                <div className="icon">
                                                    <img src="assets/img/about/icon-1.svg" alt="icon-img" />
                                                </div>
                                                <div className="content">
                                                    <h3>
                                                        <span className="count">45</span>Years
                                                    </h3>
                                                    <p>Of Experience</p>
                                                </div>
                                            </div>
                                            <div
                                                className="about-image-1 bg-cover wow fadeInLeft"
                                                data-wow-delay=".3s"
                                                style={{ backgroundImage: 'url("assets/img/about/03.png")' }}
                                            >
                                                <div
                                                    className="about-image-2 wow fadeInUp"
                                                    data-wow-delay=".5s"
                                                >
                                                    <img src="assets/img/about/trade_logo.jpg" alt="about-img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mt-4 mt-lg-0">
                                        <div className="about-content">
                                            <div className="section-title mb-3 mxw-650">
                                                <div className="subtitle">
                                                    {" "}
                                                    <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                    <span>ABOUT ITMES TRADE SERVICES</span>
                                                    <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                                </div>
                                                {/* <h2 className="title">
                                                    Facilitator of the right business connections for the growth
                                                    of trade &amp; economy
                                                </h2> */}
                                            </div>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                India ITME Society with its 40 plus years heritage has embarked
                                                on a journey to strengthen the domestic and international
                                                textile industry by facilitating multiple platforms for trade
                                                and business enhancement along with exchange of knowledge,
                                                technology transfer &amp; encouraging Foreign Direct Investments
                                                &amp; Joint Ventures in the textile industry, etc.
                                            </p>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                IITME, has always been an initiator in shaping India's textile
                                                engineering industry through its various events, it has always
                                                served as a gateway event for new entrants in Indian and Asian
                                                textile markets. IITME has now introduced a new channel to
                                                further enhance the support to the industry through Trade
                                                Services.
                                            </p>
                                            {/* <p class="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                          This initiative of Trade Desk will help build the gap between trade inquiries and trade conversions that can act as a catalyst for the multifold growth of all stakeholders. Through this trade desk, IITME can help connect startups, and small-scale business houses with the appropriate technology suppliers, global markets and assist clients in projects from conceptualization, marketing, and techno-economic feasibility to project management to actual implementation. This platform will ensure that even the smallest of the enquiries both national as well as international are reaching the appropriate producers in India leading to the growth of trade and economy and right solutions are given to the clients through expert advisors.
                      </p> */}
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                This initiative of Trade Services will help build the gap
                                                between trade inquiries and trade conversions that can act as a
                                                catalyst for the multifold growth of all stakeholders. Through
                                                trade services, IITME society will provide help to connect
                                                startups, and small-scale business with the appropriate
                                                technology suppliers, global markets and assist clients in
                                                projects from conceptualization, marketing, and techno-economic
                                                feasibility to project management to actual implementation. This
                                                platform will ensure that even the smallest of the enquiries
                                                both national as well as international are reaching the
                                                appropriate producers in India leading to the growth of trade
                                                and economy and right solutions are given to the clients through
                                                expert advisors.
                                            </p>
                                            {/* <div class="about-author">
                          <div class="about-button wow fadeInUp" data-wow-delay=".5s">
                              <a href="about.html" class="theme-btn">
                                  Explore More
                                  <i class="fa-solid fa-arrow-right-long"></i>
                              </a>
                          </div>
                      </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Offer Section Start */}
                    <section className="offer-section fix section-bg-2 section-padding">
                        <div className="line-shape">
                            <img src="assets/img/team/line-shape.png" alt="shape-img" />
                        </div>
                        <div className="mask-shape">
                            <img src="assets/img/team/mask-shape.png" alt="shape-img" />
                        </div>
                        <div className="container">
                            <div className="section-title title-area  mx-auto mb-15">
                                <div className="subtitle d-flex justify-content-center">
                                    {" "}
                                    <img src="assets/img/icon/arrowLeftWhite.svg" alt="icon" />{" "}
                                    <span className="text-white"> Practices</span>
                                    <img src="assets/img/icon/arrowRightWhite.svg" alt="icon" />
                                </div>
                                <h2 className="title text-center text-white">
                                    Trade Practices for stakeholders
                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="practice_for_stakeholder_css">
                                        <div className="offer-items">
                                            <div className="icon">
                                                <img
                                                    src="assets/img/machinery_manufacturers.png"
                                                    alt="machinery_manufacturers"
                                                />
                                            </div>
                                            <div className="content">
                                                <h5>Textile &amp; apparel manufacturers</h5>
                                            </div>
                                        </div>
                                        <div className="offer-items">
                                            <div className="icon">
                                                <img
                                                    src="assets/img/Accessory_Suppliers.png"
                                                    alt="Accessory_Suppliers"
                                                />
                                            </div>
                                            <div className="content">
                                                <h5>Machinery &amp; Accessory Suppliers</h5>
                                            </div>
                                        </div>
                                        <div className="offer-items">
                                            <div className="icon">
                                                <img src="assets/img/Agents_img.png" alt="Agents_img" />
                                            </div>
                                            <div className="content">
                                                <h5>Dealers / distributors / agents</h5>
                                            </div>
                                        </div>
                                        <div className="offer-items">
                                            <div className="icon">
                                                <img
                                                    src="assets/img/Marketing_agencies.png"
                                                    alt="Marketing_agencies"
                                                />
                                            </div>
                                            <div className="content">
                                                <h5>Trading companies</h5>
                                            </div>
                                        </div>
                                        <div className="offer-items">
                                            <div className="icon">
                                                <img
                                                    src="assets/img/regional_industries_img.png"
                                                    alt="regional_industries_img"
                                                />
                                            </div>
                                            <div className="content">
                                                <h5>Sector specific regional industries</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>



                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Itme_trade_services));